module.exports = __webpack_public_path__ + "img/body-1.811fac77.png";